const loadGoogleMapsApi = require('load-google-maps-api');

const mapValues = document.querySelector('#maps-values');

let map,
  serializer = new XMLSerializer(),
  form = document.querySelector('.form--store-locator'),
  markers = [],
  infowindow = [],
  locations = [],
  apiKey = mapValues.dataset.apiKey,
  aroundMe = false,
  mapScriptOptions = {
    'key': apiKey,
    'libraries': ['places'],
  },
  suppliersDepartments = mapValues.dataset.shopLocation,
  isDeptSpecific = mapValues.dataset.details !== 'false',
  specificArea = isDeptSpecific ? JSON.parse(mapValues.dataset.details) : null,
  baseUrl = mapValues.dataset.baseUrl,
  departmentNames = JSON.parse(mapValues.dataset.departmentList),
  searchedPostalCode,
  url = window.location.search
;

const exceptions = JSON.parse(mapValues.dataset.exceptions);
const aroundMeBtn = document.querySelector('.link--i-storelocator');
const searchParams = new URLSearchParams(url);
const postalCodeSelector = 'input[name="store_locator[postalCode]"]';
const deptSelector = 'input[name="store_locator[department]"]';
const deptCode = parseInt(mapValues.dataset.deptCode);

let template = document.querySelector('#icon-svg'),
  svg = document.importNode(template.content, true).querySelector('svg'),
  pinIconSvg = serializer.serializeToString(svg),
  pinIconImage = mapValues.dataset.pinIcon;

loadGoogleMapsApi(mapScriptOptions)
  .then(googleMaps => {
    initMap(googleMaps);

    if (isDeptSpecific) {
      clearMarkers();

      form.querySelector(deptSelector).value = deptCode;
      getSupplierForClientPostalCode();
    }
  });

function initMap(googleMaps) {
  if (isDeptSpecific) {
    map = new googleMaps.Map(document.getElementById('map'), {
      center: { lat: specificArea[0].lat, lng: specificArea[0].lng },
      zoom: 8,
    });

  } else {
    map = new googleMaps.Map(document.getElementById('map'), {
      center: { lat: 46.71109, lng: 1.7191036 },
      zoom: 6,
    });
  }

  map.data.setStyle({
    strokeWeight: 1,
    strokeOpacity: 0.5,
  });

  map.data.loadGeoJson(window.location.origin + '/media/store_locator/departments.geojson');

  map.data.setStyle(function (feature) {
    return {
      fillOpacity: atLeastOneShopInDepartment(feature.getProperty('code_dept')) ? 0.4 : 0,
      strokeWeight: 1,
      strokeOpacity: 0.3,
    };
  });

  map.data.addListener('mouseover', function (event) {
    map.data.revertStyle();
    if (atLeastOneShopInDepartment(event.feature.getProperty('code_dept'))) {
      map.data.overrideStyle(event.feature, { fillOpacity: 0.6 });
    }
  });

  map.data.addListener('mouseout', function () {
    map.data.revertStyle();
  });

  map.data.addListener('click', function (event) {
    const code = event.feature.getProperty('code_dept');

    if (atLeastOneShopInDepartment(code)) {
      window.location.href = `${baseUrl}/${code}-${getDepartmentSlug(code)}`;
    }
  });
}

function atLeastOneShopInDepartment(departmentNumber) {
  let array = JSON.parse(suppliersDepartments);
  return array.includes(parseInt(departmentNumber));
}

// Au submit du formulaire on met à jour l'affichage + push GTM
form.addEventListener('validSubmit', function (e) {
  e.preventDefault();
  managePostalCodeSearch();

  return false;
});

// Au clic sur "autour de moi", récupère le code postal à partir de la position + push GTM
aroundMeBtn.addEventListener('click', function (e) {
  e.preventDefault();
  getPosition();
  dataLayer.push({
    'event': 'Store Locator',
    'CTA': 'autour de moi',
  });
});

// Si le champ de recherche est peuplé, on lance la recherche manuellement
if (form.querySelector(postalCodeSelector).value) {
  managePostalCodeSearch(false);
}

/**
 * Si le paramètre est présent dans l'URL, on
 * déclenche la recherche par un clic sur le bouton
 * "autour de moi" et on supprime le paramètre
 * de l'URL
 */
if (searchParams.has('around-me')) {
  aroundMeBtn.click();

  let urlObj = new URL(window.location);
  urlObj.searchParams.delete('around-me');

  window.history.pushState({}, '', urlObj.toString());
}

function managePostalCodeSearch(isSubmit = true) {
  getSupplierForClientPostalCode();

  const pushData = {
    'event': 'Store Locator',
    'CTA': 'recherche',
  };

  // C'est nul mais j'en ai marre
  if (isSubmit) {
    onWithPrecondition(
      function () {
        dataLayer.push(pushData);
      },
    );
  } else {
    dataLayer.push(pushData);
  }
}

function getSupplierForClientPostalCode() {
  clearMarkers(); // On vire les marqueurs de la carte

  // Hors recherche sur un département, on s'assure que ce champ
  // est vide parce qu'à la soumission, il est prioritaire si renseigné
  if (!isDeptSpecific) {
    form.querySelector(deptSelector).value = '';
  }

  const submitButton = form.querySelector('[type="submit"]');
  submitButton.disabled = true; // On disable le bouton de soumission

  const request = new Request(
    form.action, {
      method: 'POST',
      body: new FormData(form),
    });

  fetch(request)
    .then(response => response.json())
    .then(data => {
      submitButton.disabled = false;

      if (0 < data.length) {
        searchedPostalCode = form.querySelector(postalCodeSelector).value;

        loadGoogleMapsApi(mapScriptOptions)
          .then(googleMaps => {
            updateSuppliers(data, googleMaps); // On récupère l'instance de google maps pour mettre à jour la liste
          });
      } else {
        displayNoSupplierFound();
      }
    }) // Unable le bouton submit puis met à jour la liste des distributeurs si le tableau en contient
    .catch(error => {
      submitButton.disabled = true;
      errorUpdateSuppliers();
    }); // En cas d'erreur, affiche un message
}

function displayNoSupplierFound() {
  document.getElementById('suppliers_list').innerHTML = `
            <div class="grid__item p-t-45 p-t-lg-0" data-switch-target>
              <div class="store-locator__supplier-list d-flex justify-content-center justify-content-lg-start" id="supplier_counter"></div>
              <div id="suppliers_list">
                <div class="text-center m-r-lg-90 m-t-70 m-b-180 m-t-lg-110 m-b-lg-0" id="supplier_empty">
                  <p class="w-75 w-sm-50 w-lg-100 m-t-20 mx-auto">Désolé, aucun de nos points de vente Storistes de France ne se trouve dans votre zone géographique.</p>
                </div>
              </div>
            </div>`;

  document.getElementById('supplier_counter').innerHTML = `
              <div class="row">
                <div class="counter counter--storelocator col" data-role="counter" data-placeholder="Storiste">
                  0 Storiste de France près de chez vous
                </div>
              </div>
              `;
}

// Met à jour l'affichage des distributeurs en fonction du retour ajax
function updateSuppliers(data, googleMaps) {
  clearMarkers(); // On vire les marqueurs de la carte

  let result = '';
  let loop = 1;
  let exists_in_location = false;

  const departmentCode = deptCode ? deptCode.toString() : searchedPostalCode.substring(2, 0);

  if (Object.values(exceptions).indexOf(departmentCode) > -1) {
    exists_in_location = true;
  } else {
    data.forEach((element) => {
      const supplier = JSON.parse(element);

      if (supplier.postal_code && (supplier.postal_code.substring(2, 0) === departmentCode)) {
        exists_in_location = false;
      }
    });
  }

  data.forEach((element, index) => {
    const supplier = JSON.parse(element);

    if ((exists_in_location && (supplier.postal_code.substring(2, 0) !== departmentCode))
      || (loop > 2 && form.querySelector(deptSelector).value === '')) {
      return;
    }

    const openingHours = getOpeningHours(supplier);
    const supplierUlr = supplier.canonical;

    result += `
          <div class="store-locator__content d-flex justify-content-center justify-content-lg-start m-b-20">
            <div class="store-locator__icon m-r-10" data-list-position="${loop}">
              <span class="store-locator__supplier-nb">${loop}</span>
              ${pinIconSvg}
            </div>
            <div class="store-locator_infos">
              <div class="">
                <h3 class="ff-wotfard-m fs-19 fs-md-20 m-b-10">${supplier.title}</h3>
              </div>
              <p class="ff-wotfard-l m-b-0 fs-14 fs-lg-16 ws-prewrap">${supplier.address}</p>
              <p class="ff-wotfard-l text-dark-rgba fs-14 fs-lg-16">${openingHours}</p>
              <a class="link--u link-to-supplier fs-18 fs-lg-20" href="${supplierUlr}">Voir le détail du magasin</a>
            </div>
          </div>
        `;
    // On ajoute un distributeur à la liste

    if (index !== data.length - 1) {
      result += '<hr class="d-none d-lg-block">';
    }

    let contentString = `
          <div class="bg-darkblue">
            <span class="ff-wotfard-m fs-18 text-white">${supplier.title}</span><span class="text-white"> - </span>
          </div>
          <p class="ff-wotfard-l m-b-0 m-t-12 fs-16 text-white ws-prewrap">${supplier.address}</p>
          <p class="ff-wotfard-l text-grey fs-16">${openingHours}</p>
          <div class="text-center"><a class="btn btn-outline-darkblue fs-16 p-0 ff-wotfard-m text-uppercase link-to-supplier" href="${supplierUlr}">Voir le détail du magasin</a></div>
        `;

    infowindow[loop] = new googleMaps.InfoWindow({
      content: contentString,
      maxWidth: 250,
    });
    // Ajoute un tooltip au tableau

    markers[loop] = new googleMaps.Marker({
      position: { lat: parseFloat(supplier.latitude), lng: parseFloat(supplier.longitude) },
      map: map,
      label: {
        text: loop.toString(),
        color: 'white',
      },
      icon: {
        url: pinIconImage,
        labelOrigin: new google.maps.Point(20, 18),
      },
      id: loop,
    });

    // Ajoute un marqueur au tableau

    locations[loop] = new googleMaps.LatLng(parseFloat(supplier.latitude), parseFloat(supplier.longitude));

    map.setZoom(8);
    map.setCenter({ lat: parseFloat(supplier.latitude), lng: parseFloat(supplier.longitude) });

    markers[loop].addListener('click', function () {
      infowindow[this.id].open(map, markers[this.id]);
      map.panTo(locations[this.id]);
    });
    // Ajoute un listener sur chaque marqueur et au clic :
    // - ouvre le tooltip
    // - passe le centre de la carte sur le point (selon ses coordonnées)
    // - sette le niveau de zoom

    loop++;
  });

  let count = loop - 1;
  let s = count > 1 ? 's' : '';

  let counter = `
    <div class="row">
      <div class="counter counter--storelocator col" data-role="counter" data-placeholder="Storiste">
        ${count} Storiste${s} de France près de chez vous
      </div>
    </div>
  `;

  result += `<hr class="d-none d-lg-block m-r-lg-90">`;
  document.getElementById('suppliers_list').innerHTML = result; // Ajoute les div "distributeur" à la liste
  document.getElementById('supplier_counter').innerHTML = counter; // Ajoute le compteur en haut de la liste

  let items = $('.link-to-supplier');
  if (items.length) {
    items.each(function () {
      $(this).bind('click', function () {
        dataLayer.push({
          'event': 'Store Locator',
          'CTA': 'magasin',
        });
      });
    });
  }

  isDeptSpecific = false;
}

// Récupère la position via le navigateur
function getPosition() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(showPosition);
  } else {
    console.log('Position is not supported.');
  }
}

// Remplit les values des champs et valide le formulaire pour mettre la liste à jour
function showPosition(position) {
  aroundMe = true;
  const lat = position.coords.latitude;
  const lng = position.coords.longitude;
  const mapsLatLng = new google.maps.LatLng(lat, lng);
  const geocoder = new google.maps.Geocoder();
  let postalCode = null;

  geocoder.geocode({ 'latLng': mapsLatLng }, function (results, status) {
    if (status === google.maps.GeocoderStatus.OK && 0 < results.length) {
      const component = results[0].address_components.find(component => 'postal_code' === component.types[0]);

      if (component) {
        postalCode = component.short_name;
        form.querySelector('input[type="text"]').value = postalCode;
        form.querySelector('button[type="submit"]').click();
      }
    }
  });
}

// Selon le jour de la semaine, renvoie les horaires du magasin
function getOpeningHours(element) {
  let d = new Date();
  let n = d.getDay();

  let openingHours;

  switch (n) {
    case 1:
      openingHours = element.mondayHours ?? element.monday_hours;
      break;
    case 2:
      openingHours = element.tuesdayHours ?? element.tuesday_hourss;
      break;
    case 3:
      openingHours = element.wednesdayHours ?? element.wednesday_hours;
      break;
    case 4:
      openingHours = element.thursdayHours ?? element.thursday_hours;
      break;
    case 5:
      openingHours = element.fridayHours ?? element.friday_hours;
      break;
    case 6:
      openingHours = element.saturdayHours ?? element.saturday_hours;
      break;
    case 0:
      openingHours = element.sundayHours ?? element.sunday_hours;
      break;
    default:
      openingHours = null;
  }

  if (openingHours !== null && undefined !== openingHours) {
    return `Ce magasin est ouvert aujourd'hui ${openingHours}.`;
  } else {
    return 'Ce magasin est fermé aujourd\'hui.';
  }
}

function errorUpdateSuppliers() {
  document.getElementById('suppliers_list').innerHTML = `
        <div class="text-center m-r-lg-90 m-t-70 m-b-180 m-t-lg-110 m-b-lg-0" id="supplier_empty">
          <p class="w-75 w-sm-50 w-lg-100 m-t-20 mx-auto">Erreur de communication avec le serveur.</p>
        </div>
      `;
}

function setMapOnAll(map) {
  for (var i = 0; i < markers.length; i++) {
    if (markers[i]) {
      markers[i].setMap(map);
    }
  }
}

// Supprime les marqueurs de la carte
function clearMarkers() {
  setMapOnAll(null);
}

window.addEventListener('load', function () {
  // Si #aroundme dans l'URL, on récupère la position du navigateur
  if ('#aroundme' === window.location.hash) {
    getPosition();
  }
});

function getCookie(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function getDepartmentSlug(departmentNumber) {
  return departmentNames['' + departmentNumber];
}
